import { toggleBooleanAttribute } from "@/utilities/attributes";
import { getAll, getById } from "@/utilities/querySelector";

document.addEventListener( 'DOMContentLoaded', initialise );


function initialise() {
    const buttons = getAll( '[data-form-toggle]' );
    buttons.forEach( ( button ) => {
        button.addEventListener( 'click', clickHandler );
    } );
}

function clickHandler( e ) {
    const form = get_site_form();
    form.open ? closeForm() : openForm();
}

export function get_site_form() {
    return /** @type {HTMLElement} */ ( document.getElementById( 'site-footer-form-wrapper' ) );
}

export function openForm() {
    const form = get_site_form();
    form.show();
}

export function closeForm() {
    const form = get_site_form();
    form.close();
}